import React from "react";
import { FaLock } from "react-icons/fa";
import "./customInput.sass";

const CustomInput = ({ label, value, name, disabled, onChange, pattern }) => {
  const inputClass = disabled ? "form-control mt-0 p-0 mb-0 custom-input w-100 disabled" : "form-control mt-0 p-0 mb-0 custom-input w-100";

  return (
    <div className="form-group w-100">
      <div className="custom-label fw-bold d-flex " style={{ color: "#CACCFC" }}>
        {label}
        {disabled && <FaLock className="me-1 pt-1" />}
      </div>
      <div className="input-wrapper">
        <input
          pattern={pattern ?? ""}
          onChange={onChange}
          name={name}
          type="text"
          value={value ?? " - "}
          className={inputClass}
          readOnly={disabled}
          autoComplete="off"
          style={{ color: disabled ? "gray" : "#FFF", backgroundColor: "transparent" }}
        />
      </div>
      <div className="input-underline" />
    </div>
  );
};

export default CustomInput;
